import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw9208Api } from '../../../services/pw9208Api';

export function usePW9208Navigation(
  loadRecordWithNames: (id: string) => Promise<unknown>
) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async (): Promise<string[]> => {
    try {
      const res = await pw9208Api.list(1, 200);
      const ids = (res.data || []).map(r => r.f90m_01);
      setAllIds(ids);
      return ids;
    } catch {
      return [];
    }
  }, []);

  const navTo = useCallback(
    async (idx: number, isEditing: boolean) => {
      if (isEditing) {
        message.warning('請先存檔或還原再導覽');
        return;
      }
      if (idx < 0 || idx >= allIds.length) return;
      setCurrentIdx(idx);
      await loadRecordWithNames(allIds[idx]);
    },
    [allIds, loadRecordWithNames]
  );

  return { allIds, currentIdx, setCurrentIdx, loadList, navTo };
}
